import { CarrierOptimizationsActionTypes } from './constants';

export const INIT_STATE = {
    errorGetOptimizedCarriers: null,
    loadingOptimizedCarriers: false,
    optimizedCarriers: null,
    errorGetOptimizedTransitTimeByDayServiceLevel: null,
    loadingOptimizedTransitTimeByDayServiceLevel: false,
    optimizedTransitTimeByDayServiceLevel: null,
    errorGetOptimizedTotalCost: null,
    loadingOptimizedTotalCost: false,
    optimizedTotalCost: null,
    errorGetOptimizedAvgCost: null,
    loadingOptimizedAvgCost: false,
    optimizedAvgCost: null,
    errorGetOptimizedAggregatedCostByService: null,
    loadingOptimizedAggregatedCostByService: false,
    optimizedAggregatedCostByService: null,
    errorGetOptimizedShipFromLocations: null,
    loadingOptimizedShipFromLocations: false,
    optimizedShipFromLocations: null,
};

type CarrierOptimizationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetOptimizedCarriers: null,
    loadingOptimizedCarriers: false,
    optimizedCarriers: any,
    errorGetOptimizedTransitTimeByDayServiceLevel: null,
    loadingOptimizedTransitTimeByDayServiceLevel: false,
    optimizedTransitTimeByDayServiceLevel: any,
    errorGetOptimizedTotalCost: null,
    loadingOptimizedTotalCost: false,
    optimizedTotalCost: any,
    errorGetOptimizedAvgCost: null,
    loadingOptimizedAvgCost: false,
    optimizedAvgCost: any,
    errorGetOptimizedAggregatedCostByService: null,
    loadingOptimizedAggregatedCostByService: false,
    optimizedAggregatedCostByService: any,
    errorGetOptimizedShipFromLocations: null,
    loadingOptimizedShipFromLocations: false,
    optimizedShipFromLocations: null,
};

const CarrierOptimizations = (state: State = INIT_STATE, action: CarrierOptimizationsAction): any => {
    switch (action.type) {
        case CarrierOptimizationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS: {
                    return { ...state, loadingOptimizedCarriers: false, optimizedCarriers: action.payload.data };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL: {
                    return { ...state, loadingOptimizedTransitTimeByDayServiceLevel: false, optimizedTransitTimeByDayServiceLevel: action.payload.data };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST: {
                    return { ...state, loadingOptimizedTotalCost: false, optimizedTotalCost: action.payload.data };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST: {
                    return { ...state, loadingOptimizedAvgCost: false, optimizedAvgCost: action.payload.data };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE: {
                    console.log('action.payload.data', action.payload.data);
                    return { ...state, loadingOptimizedAggregatedCostByService: false, optimizedAggregatedCostByService: action.payload.data };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS: {
                    return { ...state, loadingOptimizedShipFromLocations: false, optimizedShipFromLocations: action.payload.data };
                }
                default:
                    return { 
                        ...state, 
                        loadingOptimizedCarriers: false, 
                        loadingOptimizedTransitTimeByDayServiceLevel: false, 
                        loadingOptimizedTotalCost: false, 
                        loadingOptimizedAvgCost: false, 
                        loadingOptimizedAggregatedCostByService: false,
                        loadingOptimizedShipFromLocations: false,
                    };
            }

        case CarrierOptimizationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS: {
                    return { ...state, loadingOptimizedCarriers: false, errorGetOptimizedCarriers: action.payload.error };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL: {
                    return { ...state, loadingOptimizedTransitTimeByDayServiceLevel: false, errorGetOptimizedTransitTimeByDayServiceLevel: action.payload.error };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST: {
                    return { ...state, loadingOptimizedTotalCost: false, errorGetOptimizedTotalCost: action.payload.error };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST: {
                    return { ...state, loadingOptimizedAvgCost: false, errorGetOptimizedAvgCost: action.payload.error };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE: {
                    return { ...state, loadingOptimizedAggregatedCostByService: false, errorGetOptimizedAggregatedCostByService: action.payload.error };
                }
                case CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS: {
                    return { ...state, loadingOptimizedShipFromLocations: false, errorGetOptimizedShipFromLocations: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case CarrierOptimizationsActionTypes.GET_OPTIMIZED_CARRIERS:
            return { ...state, loadingOptimizedCarriers: true, optimizedCarriers: null };
        case CarrierOptimizationsActionTypes.GET_OPTIMIZED_TRANSIT_TIME_BY_DAY_SERVICE_LEVEL:
            return { ...state, loadingOptimizedTransitTimeByDayServiceLevel: true, optimizedTransitTimeByDayServiceLevel: null };
        case CarrierOptimizationsActionTypes.GET_OPTIMIZED_TOTAL_COST:
            return { ...state, loadingOptimizedTotalCost: true, optimizedTotalCost: null };
        case CarrierOptimizationsActionTypes.GET_OPTIMIZED_AVG_COST:
            return { ...state, loadingOptimizedAvgCost: true, optimizedAvgCost: null };
        case CarrierOptimizationsActionTypes.GET_OPTIMIZED_AGGREGATED_COST_BY_SERVICE:
            return { ...state, loadingOptimizedAggregatedCostByService: true, optimizedAggregatedCostByService: null };
        case CarrierOptimizationsActionTypes.GET_OPTIMIZED_SHIP_FROM_LOCATIONS:
            return { ...state, loadingOptimizedShipFromLocations: true, optimizedShipFromLocations: null };
        default:
            return { ...state };
    }
};

export default CarrierOptimizations;
